import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

const StepSchema = ({ formData, updateFormData }) => {
  const jsonValidation = useMemo(() => {
    if (!formData.schema || !formData.schema.trim()) {
      return { valid: false, message: 'JSON schema is required' };
    }
    try {
      JSON.parse(formData.schema);
      return { valid: true, message: 'Valid JSON' };
    } catch (e) {
      return { valid: false, message: `Invalid JSON: ${e.message}` };
    }
  }, [formData.schema]);

  return (
    <div className="wizard-step">
      <div className="step-intro">
        <h3>Define your JSON output structure</h3>
        <p>Provide the JSON schema that defines your expected output format.</p>
      </div>

      <div className="form-group">
        <label htmlFor="schema" className="form-label">
          JSON Schema
          <span className="label-required">*</span>
        </label>
        <textarea
          id="schema"
          value={formData.schema || ''}
          onChange={(e) => updateFormData('schema', e.target.value)}
          placeholder={`{
  "type": "object",
  "properties": {
    "subject": { "type": "string" },
    "body": { "type": "string" },
    "tone": { "type": "string" }
  },
  "required": ["subject", "body"]
}`}
          className={`form-textarea font-mono text-xs ${!jsonValidation.valid ? 'form-error' : ''}`}
          rows="14"
          autoFocus
        />
        <div className="flex items-center justify-between mt-2">
          <span className={`field-hint ${jsonValidation.valid ? 'text-green-400' : 'text-red-400'}`}>
            {jsonValidation.message}
          </span>
          <span className={`validation-badge ${jsonValidation.valid ? 'valid' : 'invalid'}`}>
            {jsonValidation.valid ? '✓ Valid' : '✗ Invalid'}
          </span>
        </div>
      </div>
    </div>
  );
};

StepSchema.propTypes = {
  formData: PropTypes.object.isRequired,
  updateFormData: PropTypes.func.isRequired,
};

export default StepSchema;

